// Converts a form value to a number, or `undefined` when it is empty/blank.
// Used for optional numeric lab fields: a raw `Number("")` yields 0, which the
// CDM validator rejects as out of range (NUM-RANGE). Returning `undefined` makes
// JSON.stringify drop the key entirely, so an unfilled field is not sent at all
// instead of being submitted as 0.
export const toNumberOrUndefined = (value) => {
  if (value === "" || value === null || value === undefined) return undefined;

  const parsed = Number(value);

  return Number.isNaN(parsed) ? undefined : parsed;
};
